import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class SimpleModal extends Component {
    state = {
        modal: false
    }

    toggle = () => {
        this.setState({
          modal: !this.state.modal
        });
    }

    componentDidMount(){
        this.setState({
            modal: this.props.showOnLoad
        });
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} >
                    <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
                    <ModalBody>
                        {this.props.details}
                    </ModalBody>
                    <ModalFooter>
                        {
                            this.props.okBtn ?
                                <Button color="primary" onClick={this.props.okBtnClicked}>{this.props.okBtn}</Button>
                            : ''
                        }
                        {
                            this.props.cancelBtn ?
                                <Button color="secondary" onClick={this.toggle}>{this.props.cancelBtn}</Button>
                            : ''
                        }
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default SimpleModal;


// WEBPACK FOOTER //
// ./src/components/widgets/modals/simplemodal.js